import { useParams } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import {
  CreatePayrollRunCommentDocument,
  CreatePayrollRunCommentMutation,
  PayrollCyclesDocument,
  PayrollRunCommentsDocument,
} from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import { useMutation } from 'modules/core/hooks/useMutation'
import { useQuery } from 'modules/core/hooks/useQuery'

import { CommentsCommentValues } from 'modules/comments/components/CommentsContainer/CommentEditor'
import SidepanelComments from 'modules/comments/components/Wrappers/SidepanelComments'
import { usePayrollRunParticipants } from 'modules/compensations/hooks/usePayrollRunParticipants'

import MessagesCallout from './MessagesCallout'

const Messages = () => {
  const { id } = useParams()
  const payrollRunId = Number(id)
  const bookkeeperContext = {
    isBookkeeperView: true,
  }

  const { data: payrollCyclesData } = useQuery(PayrollCyclesDocument, {
    variables: {
      ids: [payrollRunId],
    },
    context: bookkeeperContext,
  })

  const companyId =
    payrollCyclesData?.compensations?.payrollRunsConnection?.nodes?.[0]?.cycle?.company?.id ?? 0

  const { loading, data: commentsData } = useQuery(PayrollRunCommentsDocument, {
    variables: {
      id: payrollRunId,
      companyId: companyId,
    },
    context: bookkeeperContext,
  })

  const comments =
    commentsData?.compensations?.payrollRunsConnection?.nodes?.[0]?.commentsConnection?.nodes ?? []

  const participantAccessIds =
    commentsData?.compensations?.payrollRunsConnection?.nodes?.[0]?.payrollRunParticipants ?? []

  const { fetchMentionableAccesses } = usePayrollRunParticipants({
    participantAccessIds,
    isBookkeeperView: true,
  })

  const [addComment] = useMutation(CreatePayrollRunCommentDocument, {
    extractorFn: (result: CreatePayrollRunCommentMutation) =>
      result.compensationsMutations.createCommentCompensationsPayrollRun,
  })

  const handleAddComment = (variables: CommentsCommentValues) => {
    return addComment({
      variables: { ...variables, payrollRunId, companyId },
      context: bookkeeperContext,
      refetchQueries: [PayrollRunCommentsDocument],
      awaitRefetchQueries: true,
    })
  }

  if (loading) return <Loading />

  return (
    <Box padding="s24">
      <MessagesCallout
        isBookkeeperView
        payrollRunId={payrollRunId}
        hasMessages={comments.length > 0}
      />
      <SidepanelComments
        comments={comments}
        resourceId={payrollRunId}
        onAddComment={handleAddComment}
        onFetchCustomMentionableAccesses={fetchMentionableAccesses}
      />
    </Box>
  )
}

export default Messages
